<div>
  <span role="status" aria-atomic="true" aria-live="polite" tabindex="-1" class="sr-only">{{noItemsMessage}}</span>

  <label class="text-uppercase input-label" for="{{selectId}}-label" *ngIf="label !== null">
    {{label}}
    <span class="text-danger" aria-hidden="true" *ngIf="required"> *</span>
  </label>

  <ng-select #wfmSelect
             [id]="selectId"
             [items]="items"
             [selectOnTab]="true"
             [placeholder]="placeHolder"
             [clearable]="false"
             class="wfm-select"
             [virtualScroll]="true"
             (change)="updateValue()"
             labelForId="{{selectId}}-label"
             bindLabel="label"
             [ariaLabel]="comboAriaLabel"
             [ariaLabelDropdown]="dropdownAriaLabel"
             [loading]="showLoading"
             [disabled]="disabled"
             [title]="displayText(selectedItem) || placeHolder"
             loadingText="Loading"
             [tabindex]="-1"
             [(ngModel)]="selectedItem"
             (search)="onSearch($event)">
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div aria-hidden="true">
        {{'dropdown.no.items' | translate}}
      </div>
    </ng-template>

    <ng-template ng-label-tmp let-item="item">

      {{displayText(item)}}
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="wfm-select-option {{item.styleClass}}" title="{{displayText(item)}}">{{displayText(item)}}</div>

    </ng-template>

  </ng-select>

  <div [id]="selectId + '-listbox'" role="listbox" aria-hidden="true" class="screenreader-only"></div>

</div>
